export const SHOW_MESSAGE = "show_message";
export const HIDE_MESSAGE = "hide_message";
export const FETCH_START = "fetch_start";
export const FETCH_SUCCESS = "fetch_success";
export const FETCH_ERROR = "fetch_error";
export const CLEAR_STATE = "clear_state";

export const UPDATE_AUTH_USER = "update_auth_user";
export const UPDATE_LOAD_USER = "update_load_user";
export const UPDATE_TOKEN = "update_token";
export const SEND_FORGET_PASSWORD_EMAIL = "send_forget_password_email";
export const SIGNIN_GOOGLE_USER_SUCCESS = "signin_google_user_success";
export const SIGNIN_FACEBOOK_USER_SUCCESS = "signin_facebook_user_success";
export const SIGNIN_TWITTER_USER_SUCCESS = "signin_twitter_user_success";
export const SIGNIN_GITHUB_USER_SUCCESS = "signin_github_user_SUCCESS";
export const SIGNIN_USER_SUCCESS = "signin_user_success";
export const SIGNOUT_USER_SUCCESS = "signout_user_success";

export const SET_DASHBOARD_DATA = "set_dashboard_data";

export const SET_TASK_CURRENT_USER = "set_task_current_user";
export const SET_TASKS_DATA = "set_tasks_data";
export const SET_TASK_LIST_DATA = "set_task_list_data";
export const ADD_TASK = "add_task";
export const DELETE_TASK = "delete_task";
export const UPDATE_TASK = "update_task";
export const SET_FILTER_DATA = "set_filter_data";
export const ADD_TASK_LIST = "add_task_list";
export const UPDATE_TASK_LIST = "update_task_list";
export const DELETE_TASK_LIST = "delete_task_list";
export const SET_TASK_DETAIL = "set_task_detail";
export const SEND_MESSAGE = "send_message";
export const TOGGLE_SIDEBAR_COLLAPSED = "toggle_sidebar_collapsed";
export const GET_TASKS_COUNTS = "get_tasks_counts";

//mail app
export const GET_LABELS_LIST = "get_labels_list";
export const GET_CONNECTIONS_LIST = "get_connections_list";
export const GET_MAILS_LIST = "get_mails_list";
export const UPDATE_MAIL_FOLDER = "update_mail_folder";
export const UPDATE_MAIL_LABEL = "upade_mail_label";
export const UPDATE_FAVORITE_STATUS = "update_favorite_status";
export const UPDATE_READ_STATUS = "update_read_status";
export const UPDATE_IMPORTANT_STATUS = "update_important_status";
export const COMPOSE_MAIL = "compose_mail";
export const SET_FILTER_TYPE = "set_filter_type";
export const GET_SELECTED_MAIL = "GET_SELECTED_MAIL";
export const UPDATE_SELECTED_MAIL = "update_selected_mail";
export const NULLIFY_SELECTED_MAIL = "nullify_selected_mail";
export const REPLY_TO_MAIL = "reply_to_mail";
export const GET_MAIL_COUNTS = "get_mail_count";
export const ADD_LABEL = "add_label";
export const ADD_CONNECTION = "add_connection";
export const REMOVE_CONNECTION = "remove_connection";

export const SET_CHAT_USERS = "set_chat_users";
export const SET_CONTACT_USERS = "set_contact_users";
export const SET_CURRENT_USER = "set_current_user";
export const SET_CONVERSATION_DATA = "set_conversation_data";
export const SEND_NEW_CHAT_MESSAGE = "send_new_chat_message";
export const SEND_NEW_MEDIA_MESSAGE = "send_new_media_message";

//Contact App
export const GET_CONTACTS_LIST = "get_contacts_list";
export const SET_CURRENT_CONTACT = "set_current_contact";
export const CREATE_CONTACT = "create_contact";
export const UPDATE_STARRED_STATUS = "update_starred_status";
export const DELETE_CONTACT = "delete_contact";
export const UPDATE_CONTACT_LABEL = "update_contact_label";
export const UPDATE_CONTACT = "update_contact";
export const GET_CONTACT_COUNTS = "get_contact_counts";
export const UPDATE_LABEL_ITEM = "update_label_item";
export const DELETE_LABEL_ITEM = "delete_label_item";

export const GET_USER_DETAIL = "get_user_detail";
export const GET_FEED_POSTS = "get_feed_posts";
export const CREATE_POST = "create_post";
export const UPDATE_POST = "update_post";

// Users Module
export const GET_USERS = "GET_USERS";
export const ADD_USER = "ADD_USER";
export const SET_USER_DETAILS = "SET_USER_DETAILS";
export const EDIT_USER = "EDIT_USER";
export const DELETE_USER = "DELETE_USER";
export const DELETE_BULK_USERS = "DELETE_BULK_USERS";
export const GET_All_USERS = "GET_All_USERS";
export const ADD_REGISTERED_USER = "ADD_REGISTERED_USER";
export const REMOVE_USER = "REMOVE_USER";
export const REMOVE_ADDED_USER = "REMOVE_ADDED_USER";
export const GET_USER_BY_ID = "GET_USER_BY_ID";
export const CURRENT_USER = "CURRENT_USER";
export const USER_TOTAL_PAGE = "USER_TOTAL_PAGE";
export const ALL_USERS_CURRENT_PAGE = "ALL_USERS_CURRENT_PAGE";
export const SET_SEARCH_USERS_PARAMS = "SET_SEARCH_USERS_PARAMS";
export const GET_ACCESS_LIST = "GET_ACCESS_LIST";
export const ACCESS_LIST_CURRENT_PAGE = "ACCESS_LIST_CURRENT_PAGE";
export const ACCESS_LIST_TOTAL_PAGES = "ACCESS_LIST_TOTAL_PAGES";
export const REMOVE_SINGLE_ACCESS = "REMOVE_SINGLE_ACCESS";

export const GET_ACCESS_LIST_MANAGEMENT = "GET_ACCESS_LIST_MANAGEMENT";
export const AL_MANAGEMENT_CURRENT_PAGE = "AL_MANAGEMENT_CURRENT_PAGE";
export const AL_MANAGEMENT_TOTAL_PAGES = "AL_MANAGEMENT_TOTAL_PAGES";
export const REMOVE_SINGLE_AL_MANAGEMENT = "REMOVE_SINGLE_AL_MANAGEMENT";
export const GET_ADMIN_LOGS = "GET_ADMIN_LOGS";
export const ADMIN_LOGS_TOTAL_COUNT = "ADMIN_LOGS_TOTAL_COUNT";
export const ADMIN_LOGS_CURRENT_PAGE = "ADMIN_LOGS_CURRENT_PAGE";
export const GET_SINGLE_ADMIN_LOG = "GET_SINGLE_ADMIN_LOG";
export const SET_ADMIN_LOG_DB = "SET_ADMIN_LOG_DB";

// Tests Module
export const GET_TESTS = "GET_TESTS";
export const TESTS_CURRENT_PAGE = "TESTS_CURRENT_PAGE";
export const TESTS_TOTAL_PAGES = "TESTS_TOTAL_PAGES";
export const GET_ALL_QUESTIONS = "GET_ALL_QUESTIONS";
export const REMOVE_SINGLE_QUESTION = "REMOVE_SINGLE_QUESTION";
export const ADD_SINGLE_QUESTION = "ADD_SINGLE_QUESTION";
export const MINI_GAMES_LIST = "MINI_GAMES_LIST";
export const CREATED_QUIZ = "CREATED_QUIZ";
export const REMOVE_QUIZ = "REMOVE_QUIZ";
export const GET_GUIZ_BY_ID = "GET_GUIZ_BY_ID";
export const SET_ACTIVE_QUIZ_ID = "SET_ACTIVE_QUIZ_ID";
export const GET_COMMENTS_BY_ID = "GET_COMMENTS_BY_ID";
export const GET_ALL_MARATHON_EVENTS = "GET_ALL_MARATHON_EVENTS";
export const MARATHON_EVENTS_CURRENT_PAGE = "MARATHON_EVENTS_CURRENT_PAGE";
export const MARATHON_EVENTS_TOTAL_PAGES = "MARATHON_EVENTS_TOTAL_PAGES";
export const GET_MARATHON_EVENT_BY_ID = "GET_MARATHON_EVENT_BY_ID";
export const GET_MARATHON_QUESTIONS_BY_ID = "GET_MARATHON_QUESTIONS_BY_ID";
export const ADD_MARATHON_QUESTION = "ADD_MARATHON_QUESTION";
export const UPDATE_MARATHON_QUESTION = "UPDATE_MARATHON_QUESTION";
export const REMOVE_MARATHON_QUESTION = "REMOVE_MARATHON_QUESTION";
export const GET_MARATHON_TICKET_LIST = "GET_MARATHON_TICKET_LIST";
export const MARATHON_TICKET_LIST_CURRENT_PAGE =
  "MARATHON_TICKET_LIST_CURRENT_PAGE";
export const MARATHON_TICKET_LIST_TOTAL_PAGES =
  "MARATHON_TICKET_LIST_TOTAL_PAGES";
export const REMOVE_MARATHON_SINGLE_TICKET = "REMOVE_MARATHON_SINGLE_TICKET";
export const GET_MARATHON_ANSWER = "GET_MARATHON_ANSWER";
export const GET_MARATHON_SCORES = "GET_MARATHON_SCORES";
export const MARATHON_SCORES_CURRENT_PAGE = "MARATHON_SCORES_CURRENT_PAGE";
export const MARATHON_SCORES_TOTAL_PAGES = "MARATHON_SCORES_TOTAL_PAGES";
export const REMOVE_MARATHON_SINGLE_SCORE = "REMOVE_MARATHON_SINGLE_SCORE";
export const UPDATE_MARATHON_SCORE = "UPDATE_MARATHON_SCORE";


export const GET_ALL_BLOGS = "GET_ALL_BLOGS";
export const ALL_BLOGS_CURRENT_PAGE = "ALL_BLOGS_CURRENT_PAGE";
export const TOTAL_BLOGS_PAGES = "TOTAL_BLOGS_PAGES";
export const ADD_NEW_BLOG = "ADD_NEW_BLOG";
export const REMOVE_SINGLE_BLOG = "REMOVE_SINGLE_BLOG";

export const GET_QUIZ_TICKET_LIST = "GET_QUIZ_TICKET_LIST";
export const REMOVE_SINGLE_TICKET = "REMOVE_SINGLE_TICKET";

export const GET_KEYS = "GET_KEYS";
export const KEYS_TOTAL_COUNT = "KEYS_TOTAL_COUNT";
export const KEYS_CURRENT_PAGE = "KEYS_CURRENT_PAGE";
export const REMOVE_KEY = "REMOVE_KEY";
export const GET_ANSWER = "GET_ANSWER";

export const GET_VOWS = "GET_VOWS";
export const VOWS_TOTAL_COUNT = "VOWS_TOTAL_COUNT";
export const VOWS_CURRENT_PAGE = "VOWS_CURRENT_PAGE";
export const REMOVE_VOW = "REMOVE_VOW";

export const GET_SCORES = "GET_SCORES";
export const SCORES_TOTAL_COUNT = "SCORES_TOTAL_COUNT";
export const SCORES_CURRENT_PAGE = "SCORES_CURRENT_PAGE";
export const REMOVE_SCORE = "REMOVE_SCORE";

export const GET_COINS = "GET_COINS";
export const COINS_TOTAL_COUNT = "COINS_TOTAL_COUNT";
export const COINS_CURRENT_PAGE = "COINS_CURRENT_PAGE";

export const GET_QUIZ_CHEATS = "GET_QUIZ_CHEATS";
export const QUIZ_CHEATS_CURRENT_PAGE = "QUIZ_CHEATS_CURRENT_PAGE";
export const QUIZ_CHEATS_TOTAL_PAGES = "QUIZ_CHEATS_TOTAL_PAGES";

export const GET_WORDS = "GET_WORDS";
export const WORDS_TOTAL_COUNT = "WORDS_TOTAL_COUNT";
export const WORDS_CURRENT_PAGE = "WORDS_CURRENT_PAGE";
export const REMOVE_WORD = "REMOVE_WORD";

export const GET_WGEVENTS = "GET_WGEVENTS";
export const WGEVENTS_TOTAL_COUNT = "WGEVENTS_TOTAL_COUNT";
export const WGEVENTS_CURRENT_PAGE = "WGEVENTS_CURRENT_PAGE";
export const REMOVE_WGEVENT = "REMOVE_WGEVENT";

export const GET_PARTICIPANTS = "GET_PARTICIPANTS";
export const PARTICIPANTS_TOTAL_COUNT = "PARTICIPANTS_TOTAL_COUNT";
export const PARTICIPANTS_CURRENT_PAGE = "PARTICIPANTS_CURRENT_PAGE";

// Events Module
export const GET_ALL_EVENTS = "GET_ALL_EVENTS";
export const SET_SINGLE_EVENT = "SET_SINGLE_EVENT";
export const REMOVE_SINGLE_EVENT = "REMOVE_SINGLE_EVENT";
export const SET_SINGLE_SECTION = "SET_SINGLE_SECTION";
export const ADD_EVENT_SECTION = "ADD_EVENT_SECTION";
export const SET_EVENT_SECTIONS = "SET_EVENT_SECTIONS";
export const REMOVE_EVENT_SECTION = "REMOVE_EVENT_SECTION";
export const SET_SECTION_TICKETS = "SET_SECTION_TICKETS";
export const REMOVE_SECTION_TICKET = "REMOVE_SECTION_TICKET";
export const SET_EVET_TICKET_TOKEN_LIST = "SET_EVET_TICKET_TOKEN_LIST";
export const SET_SINGLE_WGEVENT = "SET_SINGLE_WGEVENT";
export const GET_ACTIVE_WGEVENT = "GET_ACTIVE_WGEVENT";

// Media Module
export const SET_ALL_MEDIA = "SET_ALL_MEDIA";
export const ALL_MEDIA_CURRENT_PAGE = "ALL_MEDIA_CURRENT_PAGE";
export const TOTAL_MEDIA_PAGES = "TOTAL_MEDIA_PAGES";
export const LOADING_REMOVE_MEDIA = "LOADING_REMOVE_MEDIA";
export const REMOVED_MEDIA_ID = "REMOVED_MEDIA_ID";
export const GET_ALL_GALLERIES = "GET_ALL_GALLERIES";
export const ALL_GALLERIES_CURRENT_PAGE = "ALL_GALLERIES_CURRENT_PAGE";
export const TOTAL_GALLERY_PAGES = "TOTAL_GALLERY_PAGES";

// Banner Module
export const GET_ALL_BANNERS = "GET_ALL_BANNERS";
export const ADD_NEW_BANNER = "ADD_NEW_BANNER";
export const REMOVE_SINGLE_BANNER = "REMOVE_SINGLE_BANNER";
export const BANNERS_CURRENT_PAGE = "BANNERS_CURRENT_PAGE";
export const BANNERS_TOTAL_PAGES = "BANNERS_TOTAL_PAGES";

// Form Builder
export const SET_FORM_SETTINGS = "SET_FORM_SETTINGS";
export const SET_FORM_FIELDS = "SET_FORM_FIELDS";
export const ADD_FORM_FIELD = "ADD_FORM_FIELD";
export const ADD_FORM_FIELD_AT_INDEX = "ADD_FORM_FIELD_AT_INDEX";
export const REMOVE_FORM_FIELD = "REMOVE_FORM_FIELD";
export const SET_EDITING_FIELD = "SET_EDITING_FIELD";
export const SET_ALL_FORMS = "SET_ALL_FORMS";
export const SET_FORMS_CURRENT_PAGE = "SET_FORMS_CURRENT_PAGE";
export const SET_FORMS_TOTAL_PAGES = "SET_FORMS_TOTAL_PAGES";
export const DELETE_FROM_FIELD = "DELETE_FROM_FIELD";
export const SET_SINGLE_FORM = "SET_SINGLE_FORM";
export const SET_CURR_SETTINGS = "SET_CURR_SETTINGS";
export const SET_FILL_FORMS = "SET_FILL_FORMS";
export const FILL_FORMS_CURRENT_PAGE = "FILL_FORMS_CURRENT_PAGE";
export const FILL_FORMS_TOTAL_PAGES = "FILL_FORMS_TOTAL_PAGES";
export const FILL_FORM_TOTAL_DOCS = "FILL_FORM_TOTAL_DOCS";
export const REMOVE_SINGLE_FORM_FILL = "REMOVE_SINGLE_FORM_FILL";
export const SET_SINGLE_FORM_FILL = "SET_SINGLE_FORM_FILL";
export const FORM_INPUT_SEARCH = "FORM_INPUT_SEARCH";

// point shop
export const GET_ALL_PRIZES = "GET_ALL_PRIZES";
export const PRIZES_CURRENT_PAGE = "PRIZES_CURRENT_PAGE";
export const TOTAL_PRIZES_PAGES = "TOTAL_PRIZES_PAGES";
export const REMOVE_PRIZE = "REMOVE_PRIZE";
export const GET_SINGLE_PRIZE = "GET_SINGLE_PRIZE";
export const GET_ALL_POINTS = "GET_ALL_POINTS";
export const POINTS_CURRENT_PAGE = "POINTS_CURRENT_PAGE";
export const TOTAL_POINTS_PAGES = "TOTAL_POINTS_PAGES";
export const GET_ALL_POINTS_BANK = "GET_ALL_POINTS_BANK";
export const POINTS_BANK_CURRENT_PAGE = "POINTS_BANK_CURRENT_PAGE";
export const TOTAL_POINTS_BANK_PAGES = "TOTAL_POINTS_BANK_PAGES";
export const GET_ALL_PURCHASES = "GET_ALL_PURCHASES";
export const PURCHASES_CURRENT_PAGE = "PURCHASES_CURRENT_PAGE";
export const PURCHASES_TOTAL_PAGES = "PURCHASES_TOTAL_PAGES";
export const GET_SINGLE_PURCHASE = "GET_SINGLE_PURCHASE";

// Notifications
export const GET_ALL_NOTIFICATIONS = "GET_ALL_NOTIFICATIONS";
export const NOTIFICATIONS_CURRENT_PAGE = "NOTIFICATIONS_CURRENT_PAGE";
export const TOTAL_NOTIFICATIONS_PAGES = "TOTAL_NOTIFICATIONS_PAGES";

//tickets
export const SET_TICKETS = "SET_TICKETS";
export const SET_TICKETS_CURRENT_PAGE = "SET_CURRENT_PAGE";
export const SET_TICKETS_TOTAL_PAGES = "SET_TOTAL_PAGES";
export const SET_TICKETS_TOTAL_DOCS = "SET_TOTAL_DOCS";
export const SET_SINGLE_TICKET = "SET_SINGLE_TICKET";
export const SET_TICKETS_STATUS = "SET_TICKETS_STATUS";

// hubble
export const SET_HUBBLE_FORMS = "SET_HUBBLE_FORMS";
export const SET_HUBBLE_CURRENT_PAGE = "SET_HUBBLE_CURRENT_PAGE";
export const SET_HUBBLE_TOTAL_PAGES = "SET_HUBBLE_TOTAL_PAGES";
export const SET_HUBBLE_TOTAL_DOCS = "SET_TOTAL_DOCS";
export const SET_SINGLE_HUBBLE_FORM = "SET_SINGLE_HUBBLE_FORM";
export const SET_HUBBLE_JUDGES = "SET_HUBBLE_JUDGES";
export const SET_HUBBLE_REFEREE = "SET_HUBBLE_REFEREE";
export const SET_HUBBLE_REFEREE_CURRENT_PAGE =
  "SET_HUBBLE_REFEREE_CURRENT_PAGE";
export const SET_HUBBLE_REFEREE_TOTAL_PAGES = "SET_HUBBLE_REFEREE_TOTAL_PAGES";
export const SET_HUBBLE_REFEREE_TOTAL_DOCS = "SET_HUBBLE_REFEREE_TOTAL_DOCS";
export const SET_SINGLE_HUBBLE_REFEREE = "SET_SINGLE_HUBBLE_REFEREE";
export const SET_SELECTED_JUDGE = "SET_SELECTED_JUDGE";
